module.exports = __webpack_public_path__ + "assets/img/kv-459f4a9e.jpg";